import React, { Component } from 'react';

import './TimelineItem.scss';

import renderHTML from 'react-render-html';

import {
    PositionCalculator
} from '../utils/';

class TimelineItem extends Component {

	constructor() {
        super();

        this.calculator = PositionCalculator;
	}

    componentDidMount() {
    }

    componentWillUnount() {
    }

	render() {
        let itemClasses = [
            'timeline_item',
            this.props.className
        ];

        let x = this.calculator.proportionalWidth(this.props.x);
        let y = this.calculator.proportionalHeight(this.props.y);

        let itemStyle = {
            left: x + 'px',
            top: y + 'px'
        };

        return (
            <div className={ itemClasses.join(' ') } style={ itemStyle }>
                <div className="timeline_item__body">
                    <div className="timeline_item__title">
                        <span className="number">{ renderHTML(this.props.number) }</span>
                        <h3 className="title">{ renderHTML(this.props.title) }</h3>
                    </div>
                    <nav>
                        <ul>
                            { this.props.children }
                        </ul>
                    </nav>
                </div>
            </div>
    	);
	}
}

export { TimelineItem };